import { useEffect, useRef, useState } from 'react';

import { FormErrors } from './interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useTrackFormChanges<T extends Record<string, any>>(formData: T) {
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const prevFormData = useRef<T>(formData);

  useEffect(() => {
    const changedKeys = Object.keys(formData).filter((key) => {
      return formData[key] !== prevFormData.current[key];
    });

    if (changedKeys.length === 0) {
      return;
    }

    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      changedKeys.forEach((key) => {
        delete updatedErrors[key];
      });

      return updatedErrors;
    });

    prevFormData.current = formData;
  }, [formData]);

  return { formErrors, setFormErrors };
}

export default useTrackFormChanges;
